"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(audioUrl) {
    var AudioContext, audioContext, audioBuffer, channel, blockDuration, samplesPerBlock, timeData, i, avg;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            AudioContext = window.AudioContext || window.webkitAudioContext;
            audioContext = new AudioContext();
            _context.next = 4;
            return fetch(audioUrl).then(function (res) {
              return res.arrayBuffer();
            }).then(function (arBuf) {
              return audioContext.decodeAudioData(arBuf);
            });

          case 4:
            audioBuffer = _context.sent;
            // Convert into timeData
            channel = audioBuffer.getChannelData(0);
            blockDuration = 1;
            samplesPerBlock = audioBuffer.sampleRate * (blockDuration / 1000);
            timeData = [];

            for (i = 0; i < channel.length; i += samplesPerBlock) {
              avg = channel.slice(i, i + samplesPerBlock).reduce(function (acc, a) {
                return acc + a;
              }, 0) / samplesPerBlock;
              timeData.push({
                time: i * (1 / audioBuffer.sampleRate) * 1000,
                value: avg
              });
            }

            return _context.abrupt("return", timeData);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = _default;